export default __webpack_public_path__ + "static/download-app-loop-once-07c314b19120cb80fd185ef39aec8df5.gif";